/* Non-critical fonts */
document.addEventListener("DOMContentLoaded", function() {
    var style = document.createElement("style");
    style.textContent = `@font-face{font-family:"Druk Text Super Trial";src:url("https://d2izr24fok1gc0.cloudfront.net/vitahustle_new_challenger/DrukText-Super.woff2")format("woff2"),url("https://d2izr24fok1gc0.cloudfront.net/vitahustle_new_challenger/DrukText-Super.woff")format("woff");font-weight:900;font-style:normal;font-display:swap;}@font-face{font-family:"Lato";src:url("https://d2izr24fok1gc0.cloudfront.net/vitahustle_new_challenger/Lato-Regular.woff2")format("woff2");font-weight:normal;font-style:normal;font-display:swap;}@font-face{font-family:"Lato Bold";src:url("https://d2izr24fok1gc0.cloudfront.net/vitahustle_new_challenger/Lato-Bold.woff2")format("woff2");font-weight:bold;font-style:normal;font-display:swap;}@font-face{font-family:"Lato Heavy";src:url("https://d2izr24fok1gc0.cloudfront.net/vitahustle_new_challenger/Lato-Heavy.woff2")format("woff2");font-weight:900;font-style:normal;font-display:swap;}@font-face{font-family:"Druk Bold";src:url("https://d2izr24fok1gc0.cloudfront.net/vitahustle_new_challenger/Druk-Bold-Web_4.woff2")format("woff2");font-weight:700;font-style:normal;font-display:swap;}@font-face{font-family:"FKGrotesk Bold";src:url("https://d2izr24fok1gc0.cloudfront.net/vitahustle_new_challenger/FKGrotesk-Bold.woff2")format("woff2");font-weight:700;font-style:normal;font-display:swap;}@font-face{font-family:"FKGrotesk Regular";src:url("https://d2izr24fok1gc0.cloudfront.net/vitahustle_new_challenger/FKGroteskNeue-Regular.woff2")format("woff2");font-weight:400;font-style:normal;font-display:swap;}`;
    document.head.appendChild(style);
});
/* Start Section challenger_featured-product_hnVNryz */
var addCartText = "TRY IT NOW";
var soldOutText = "SOLD OUT";
document.addEventListener('DOMContentLoaded', function() {
    var swiper = new Swiper('.product-3-thumbnails-template--challenger_featured-product_hnVNryz .swiper-slider', {
        direction: 'horizontal',
        slidesPerView: '6',
        spaceBetween: 10,
        grabCursor: true,
        loop: false,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: '.product-3-thumbnails-template--challenger_featured-product_hnVNryz .product-3-thumbnails-next',
            prevEl: '.product-3-thumbnails-template--challenger_featured-product_hnVNryz .product-3-thumbnails-prev',
        },
    });
    var Swipes2 = new Swiper('.product-3-carousel-template--challenger_featured-product_hnVNryz', {
        shortSwipes: true,
        resizeObserver: true,
        observer: true,
        observeParents: true,
        loop: false,
        slidesPerView: 1,
        grabCursor: true,
        navigation: {
            nextEl: '.product-3-carousel-template--challenger_featured-product_hnVNryz .swiper-button-next',
            prevEl: '.product-3-carousel-template--challenger_featured-product_hnVNryz .swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        thumbs: {
            swiper: swiper,
        },
    });
    const thisOptions = document.querySelector('.section-template--challenger_featured-product_hnVNryz .challenger-variant');
    thisOptions?.addEventListener('change', (e) => {
        const thisParent = e.target.closest('product-component');
        const priceMain = thisParent.querySelector('.product-price');
        const priceSale = thisParent.querySelector('.product-sel-price');
        const priceParent = priceMain.closest('div');
        const thisIdSelector = `#${thisOptions.dataset.id}` + " " + `input[name="id"]`;
        const thisPlanSelector = `#${thisOptions.dataset.id}` + " " + `input[name="selling_plan"]`;
        const thisId = thisParent.querySelector(thisIdSelector);
        const thisSellingPlan = thisParent.querySelector(thisPlanSelector);
        let thisFormVariantData, thisFormCurrentVariant, thisFormOptions;
        const updateOptions = () => {
            thisFormOptions = Array.from(thisOptions.querySelectorAll('input.form-control[type="radio"]:checked'), (element) => {
                return element.value;
            });
        };
        const updateMasterId = () => {
            const variants = getVariantData();
            thisFormCurrentVariant = variants.find((variant) => {
                return !variant.options.map((option, index) => {
                    return thisFormOptions[index] === option;
                }).includes(false);
            });
        };
        const getVariantData = () => {
            if (!thisFormVariantData) {
                thisFormVariantData = JSON.parse(thisOptions.querySelector(".wwaiVariantData").getAttribute("data-variant"));
            }
            return thisFormVariantData;
        };
        updateOptions();
        updateMasterId();
        if (thisFormCurrentVariant) {
            if (thisId) {
                thisId.value = thisFormCurrentVariant.id;

            }
            // thisParent.querySelector('[data-selected-name]').innerText=thisFormCurrentVariant.title;
            var selling_plan;
            priceMain.innerText = '$' + (thisFormCurrentVariant.price / 100).toFixed(2);
            priceSale.innerText = '$' + (thisFormCurrentVariant.compare_at_price / 100).toFixed(2);
            if (thisFormCurrentVariant.price < thisFormCurrentVariant.compare_at_price) {
                priceParent.classList.add('saleing');
            } else {
                priceParent.classList.remove('saleing');
            }
            if (thisFormCurrentVariant.title.toLowerCase() == "vanilla") {
                Swipes2.slideTo(1, 1000, true);
            } else if (thisFormCurrentVariant.title.toLowerCase() == "chocolate") {
                Swipes2.slideTo(0, 1000, true);
            }
            if (thisFormCurrentVariant.title.toLowerCase() == "strawberry") {
                Swipes2.slideTo(2, 1000, true);
            } else if (thisFormCurrentVariant.title.toLowerCase() == "cookies & cream") {
                Swipes2.slideTo(3, 1000, true);
            } else {
                console.log("Flavor does not exist.");
            }
        }
    });
});

/* End Section challenger_featured-product_hnVNryz */
/* Start Section challenger_faq_with_iocn_HCEpeQa */
document.addEventListener("DOMContentLoaded", function() {
    const tabTitles = document.querySelectorAll('.cha_faq_icon-title');
    const tabBlocks = document.querySelectorAll('.cha_faq_icon-blocks');

    function switchTab(event) {
        const selectedTab = event.target.getAttribute('data-tab');
        tabTitles.forEach(title => title.classList.remove('active'));
        tabBlocks.forEach(block => block.classList.remove('active'));
        event.target.classList.add('active');
        document.querySelector(`.cha_faq_icon-blocks[data-tab="${selectedTab}"]`).classList.add('active');
    }
    tabTitles.forEach(title => {
        title.addEventListener('click', switchTab);
    });
});
/* End Section challenger_faq_with_iocn_HCEpeQa */
/* Start Section challenger_reviews_bVCmrr */
document.addEventListener('DOMContentLoaded', function() {
    const players = Array.from(document.querySelectorAll('.plyr-template--challenger_reviews_bVCmrr')).map(p => {
        const player = new Plyr(p, {
            controls: [],
            fullscreen: {
                enabled: false
            },
            autoplay: false
        });
        return {
            player,
            videoId: p.id
        };
    });

    function pauseAllVideos(exceptIndex = -1) {
        players.forEach(({
            player
        }, index) => {
            if (index !== exceptIndex && !player.paused) {
                player.pause();
                document.getElementById(`play-button-template--challenger_reviews_bVCmrr-${index+1}`).classList.remove('hidden-template--challenger_reviews_bVCmrr');
            }
        });
    }
    players.forEach(({
        player
    }, index) => {
        const playButton = document.getElementById(`play-button-template--challenger_reviews_bVCmrr-${index+1}`);
        const videoSpinner = document.getElementById(`spinner-template--challenger_reviews_bVCmrr-${index+1}`);
        playButton.addEventListener('click', function() {
            event.preventDefault();
            event.stopPropagation();
            pauseAllVideos(index);
            videoSpinner.classList.remove('spinner-hidden-template--challenger_reviews_bVCmrr');
            player.play().then(() => {}).catch(error => {
                videoSpinner.classList.add('spinner-hidden-template--challenger_reviews_bVCmrr');
            });
            playButton.classList.add('hidden-template--challenger_reviews_bVCmrr');
        });
        player.on('canplay', function() {
            videoSpinner.classList.add('spinner-hidden-template--challenger_reviews_bVCmrr');
        });
        player.on('waiting', function() {
            videoSpinner.classList.remove('spinner-hidden-template--challenger_reviews_bVCmrr');
        });
        player.on('playing', function() {
            videoSpinner.classList.add('spinner-hidden-template--challenger_reviews_bVCmrr');
        });
        player.on('pause', function() {
            playButton.classList.remove('hidden-template--challenger_reviews_bVCmrr');
        });
        player.on('ended', function() {
            playButton.classList.remove('hidden-template--challenger_reviews_bVCmrr');
        });
        player.elements.container.addEventListener('click', function() {
            event.preventDefault();
            event.stopPropagation();
            if (!player.paused) {
                player.pause();
                playButton.classList.remove('hidden-template--challenger_reviews_bVCmrr');
                videoSpinner.classList.add('spinner-hidden-template--challenger_reviews_bVCmrr');
            }
        });
    });
    var swiper = new Swiper('.reviews-section-2-template--challenger_reviews_bVCmrr', {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.reviews-section-2-template--challenger_reviews_bVCmrr .swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.reviews-section-2-template--challenger_reviews_bVCmrr .swiper-button-next',
            prevEl: '.reviews-section-2-template--challenger_reviews_bVCmrr .swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 3.2,
                spaceBetween: 15,
            },
            1024: {
                slidesPerView: 4.2,
                spaceBetween: 20,
            },
        },
        on: {
            slideChangeTransitionEnd: function() {
                const activeIndex = swiper.realIndex;
                pauseAllVideos();
                const playButton = document.getElementById(`play-button-template--challenger_reviews_bVCmrr-${activeIndex+1}`);
                if (playButton) {
                    playButton.classList.remove('hidden-template--challenger_reviews_bVCmrr');
                }
            }
        }
    });
    const videos = document.querySelectorAll(`.reviews-section-2-template--challenger_reviews_bVCmrr video[data-lazyposter]`);
    const lazyLoadPoster = (video) => {
        const posterSrc = video.getAttribute('data-lazyposter');
        if (posterSrc) {
            video.setAttribute('poster', posterSrc);
            video.removeAttribute('data-lazyposter');
        }
        const plyrInstance = players.find(obj => obj.videoId === video.id);
        if (plyrInstance) {
            if (posterSrc) {
                plyrInstance.player.poster = posterSrc;
                plyrInstance.player.play();
                plyrInstance.player.pause();
            }
        }
    };
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const video = entry.target;
                lazyLoadPoster(video);
                observer.unobserve(video);
            }
        });
    });
    videos.forEach(video => {
        observer.observe(video);
    });
});
/* End Section challenger_reviews_bVCmrr */

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});